<template>
  <div class="content">
    <div class="ttile">
      标题
      <p>
        说明：固定标题文本样式，链接地址仅针对小程序跳转生效。
      </p>
    </div>

    <div class="set-content">
      <div
        class="set-item title-box"
        v-for="item of formItems"
        :key="item.type"
      >
        <p><span v-if="item.require">*</span>{{ item.title }}</p>
        <div v-if="item.type === 'title'">
          <el-input
            v-model="curComponent.title"
            placeholder="请输入页面标题"
            size="mini"
          ></el-input>
          <p
            v-if="!curComponent.title"
            style="font-size: 12px;color: red;padding-top: 10px;"
          >
            请填写页面标题
          </p>
        </div>

        <div v-else-if="item.type === 'date'">
          <el-date-picker
            v-model="curComponent.date"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期"
          >
          </el-date-picker>
          <p
            v-if="!curComponent.date"
            style="font-size: 12px;color: red;padding-top: 10px;"
          >
            请选择日期
          </p>
        </div>

        <div v-if="item.type === 'autherName'">
          <el-input
            v-model="curComponent.autherName"
            placeholder="请输入作者名称"
            size="mini"
          ></el-input>
        </div>

        <div v-if="item.type === 'linkTitle'">
          <el-input
            v-model="curComponent.linkTitle"
            placeholder="请输入链接标题"
            size="mini"
          ></el-input>
        </div>

        <div v-if="item.type === 'selectStyle'">
          <SelectStyle v-model="curComponent.selectStyle" />
        </div>

        <div v-if="item.type === 'link'">
          <SelectJumpLink
            :showTitle="false"
            :path="curComponent.link"
            @change="
              val => {
                curComponent.link = val;
              }
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectStyle from "./components/SelectStyle";
import SelectJumpLink from "../../../components/SelectJumpLink";
export default {
  inject: ["control"],
  components: {
    SelectStyle,
    SelectJumpLink
  },
  computed: {
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    }
  },
  data() {
    return {
      formItems: [
        {
          title: "页面标题",
          require: true,
          type: "title"
        },
        {
          title: "日期",
          require: true,
          type: "date"
        },
        {
          title: "作者名称",
          require: false,
          type: "autherName"
        },
        {
          title: "链接标题",
          require: false,
          type: "linkTitle"
        },
        {
          title: "选择样式",
          require: false,
          type: "selectStyle"
        },
        {
          title: "链接地址",
          require: false,
          type: "link"
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    p {
      font-size: 10px;
      color: #999999;
      margin-top: 4px;
    }
  }
  > .set-content {
    > .title-box {
      padding-top: 20px;
    }
    > .color-box {
      display: flex;
      align-items: center;
      /deep/ .el-radio-group {
        .el-radio__input.is-checked .el-radio__inner {
          border: #2154f4;
          background: #2154f4;
        }
        .el-radio__input.is-checked + .el-radio__label {
          color: #2154f4;
        }
      }
    }
    > .set-item {
      display: flex;
      padding-right: 34px;
      padding-left: 24px;
      padding-top: 20px;
      > p {
        font-size: 12px;
        margin-right: 23px;
        color: #999999;
        line-height: 32px;
        width: 53px;
        > span {
          color: red;
        }
      }
      .picker-box {
        display: flex;
        flex-direction: row-reverse;
        padding-top: 20px;
        margin-right: 20px;
      }
      > div {
        flex: 1;
        /deep/ .el-input {
          .el-input__inner {
            height: 32px;
            line-height: 32px;
            background: #ffffff;
            border-radius: 2px;
            border: 1px solid #eeeeee;
            padding: 0 8px;
          }
        }
        /deep/ .el-date-editor {
          width: 100%;
          .el-input__prefix {
            left: auto;
            right: 5px;
          }
          .el-input__suffix {
            right: 25px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/TitleText/Attr.vue